/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import ExpiredImg from 'Assets/images/pages/web-chat/expired.svg';
import classNames from 'classnames';
import { CERT_VOIDED_STATUS, CURRENCY_SYMBOLS } from 'Constants/commons';
import { MODAL_TYPES } from 'Constants/modal';
import useVoidCert from 'Hooks/teleconsult/useVoidCert';
import ConfirmModal from 'Modules/ConfirmModal/ConfirmModal';
import { CurrencyLabel } from 'Modules/Currency';
import ModalPDFView from 'Modules/PdfViewer/PDFViewModal';
import Space from 'Modules/Space';
import { func, shape, string } from 'prop-types';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addModal, removeModal } from 'Redux/modules/modal/actions';
import { Button, Icon, Image } from 'semantic-ui-react';
import { PHARMACY_SOURCE_LIFEPACK, LifepackPrescriptionStatus } from 'Constants/consults';

import ModalMedicineRequest from '../../ModalMedicineRequest';

import FaceScanScore from './FaceScanScore';
import style from './MessageAction.less';
import SpinClock from './SpinClock';

const getActions = (list, user) =>
  list.filter(({ viewer }) => (viewer && viewer.includes(user)) || !viewer);

const EXPIRED_STATUS = 'expired';
const IMAGES = {
  'memo.detail': require('Assets/images/pages/web-chat/memo.svg'),
  'referral_memo.detail': require('Assets/images/pages/web-chat/memo.svg'),
  'emc.doctor_create': require('Assets/images/pages/web-chat/emc.svg'),
  'emc.patient_request': require('Assets/images/pages/web-chat/emc.svg'),
  'digi_emc.doctor_create': require('Assets/images/pages/web-chat/emc.svg'),
  'prescription.issue_order': require('Assets/images/pages/web-chat/prescription.svg'),
  'medicine_request.patient.create': require('Assets/images/pages/web-chat/prescription.svg'),
  'medicine_request.doctor.issue': require('Assets/images/pages/web-chat/prescription.svg'),
  doctor_create_pos: require('Assets/images/pages/web-chat/pos.svg'),
  'art.patient.detail': require('Assets/images/pages/web-chat/patient.svg'),
  'issue.patient.create': require('Assets/images/pages/web-chat/icon-issue-consult.svg'),
  'ai_face_scan.detail': require('Assets/icons/icon-face-scan.svg'),
};

const getAction = (type, actions) => actions?.filter(e => e.type === type)[0];

const formatTitle = (type, title) => {
  if (type === 'action_forward_emc') return 'View details';
  return title;
};

const checkLifepackPaymentSuccess = attachment => {
  if (
    attachment.properties?.lifepackPrescriptionStatus ===
    LifepackPrescriptionStatus.PAYMENT_SUCCESSFUL
  ) {
    return 'succeeded';
  }

  return null;
};

const getStatusPayment = attachment => {
  switch (attachment.id) {
    case 'memo.detail':
      if (getAction('memo_view_detail', attachment.actions)?.extraData?.amount > 0) {
        return getAction('memo_view_detail', attachment.actions)?.extraData?.paymentStatus;
      }
      return null;
    case 'doctor_create_pos':
      return attachment.properties.posStatus;
    case 'prescription.issue_order':
    case 'medicine_request.doctor.issue':
    case 'medicine_request.patient.create':
    case 'social_prescription_request.doctor.issue':
    case 'medicine_request.patient.create.issue_order':
      return attachment.properties?.paymentStatus ?? 'pending';
    default:
      return null;
  }
};

const useOpenFile = () => {
  const [isOpenFile, setOpenFile] = useState(false);
  const [fileName, setFileName] = useState(null);
  const [fileId, setFileId] = useState(null);
  const openFile = (id, name) => {
    setFileId(id);
    setFileName(name);
    setOpenFile(true);
  };

  const onClose = () => {
    setFileId(null);
    setOpenFile(false);
  };

  return {
    isOpenFile,
    fileId,
    openFile,
    onClose,
    fileName,
  };
};

const renderPaidImg = attachment => {
  let statusReturn = null;
  if (attachment.id === 'memo.detail') {
    const actionObj = getAction('memo_view_detail', attachment.actions);
    statusReturn = actionObj?.extraData?.paymentStatus;
  }
  if (
    attachment.id === 'prescription.issue_order' ||
    attachment.id === 'social_prescription_request.doctor.issue' ||
    attachment.id === 'medicine_request.doctor.issue'
  ) {
    const actionObj = attachment.properties;
    statusReturn = actionObj?.paymentStatus || checkLifepackPaymentSuccess(attachment);
  }
  if (attachment.id === 'doctor_create_pos') {
    const actionObj = attachment.properties;
    statusReturn = actionObj?.posStatus;
  }
  if (
    (statusReturn === 'succeeded' && attachment.id === 'prescription.issue_order') ||
    (statusReturn === 'success' && attachment.id === 'memo.detail') ||
    (statusReturn === 'paid' && attachment.id === 'doctor_create_pos') ||
    (statusReturn === 'paid' && attachment.id === 'medicine_request.doctor.issue') ||
    (statusReturn === 'paid' && attachment.id === 'social_prescription_request.doctor.issue')
  ) {
    return (
      <img alt="paid" src={require('Assets/images/paid_confirm.png')} className={style.paidImg} />
    );
  }
  return '';
};

const renderPrice = attachment => {
  if (attachment.id === 'memo.detail') {
    const actionObj = getAction('memo_view_detail', attachment.actions);
    if (actionObj?.extraData?.amount > 0 || actionObj?.extraData?.total > 0) {
      return (
        <div className={style.price}>
          {CURRENCY_SYMBOLS[actionObj?.extraData?.currency] || ''}{' '}
          <CurrencyLabel value={actionObj?.extraData?.total ?? actionObj?.extraData?.amount ?? 0} />
        </div>
      );
    }
  }
  if (attachment.id === 'doctor_create_pos') {
    const actionObj = attachment.properties;
    return (
      <div className={style.price}>
        {CURRENCY_SYMBOLS[actionObj.posCurrency] || ''}{' '}
        <CurrencyLabel value={actionObj.posTotal || 0} />
      </div>
    );
  }
  if (
    attachment.id === 'prescription.issue_order' ||
    attachment.id === 'medicine_request.doctor.issue' ||
    attachment.id === 'social_prescription_request.doctor.issue'
  ) {
    const actionObj = attachment?.properties;
    return (
      <div className={style.price}>
        {CURRENCY_SYMBOLS[actionObj?.currency] || ''}{' '}
        <CurrencyLabel value={actionObj?.total || 0} />
      </div>
    );
  }
  return '';
};

const renderStatus = attachment => {
  if (
    attachment?.properties?.certStatus === CERT_VOIDED_STATUS ||
    attachment?.properties?.documentStatus === CERT_VOIDED_STATUS
  ) {
    return (
      <div className={classNames([style.status, 'error'])}>
        <img alt="expired" src={ExpiredImg} />
        Voided
      </div>
    );
  }

  if (
    attachment?.properties?.status === EXPIRED_STATUS ||
    attachment?.properties?.prescriptionStatus === EXPIRED_STATUS
  ) {
    return (
      <div className={classNames([style.status, 'error'])}>
        <img alt="expired" src={ExpiredImg} />
        Expired
      </div>
    );
  }

  if (
    attachment?.properties?.prescriptionStatus === 'cancelled' ||
    [
      LifepackPrescriptionStatus.PRESCRIPTION_REJECTED,
      LifepackPrescriptionStatus.ORDER_CANCELLED,
      LifepackPrescriptionStatus.PAYMENT_FAILED,
    ].includes(attachment.properties?.lifepackPrescriptionStatus)
  ) {
    return (
      <div className={classNames([style.status, 'error'])}>
        <img alt="expired" src={ExpiredImg} />
        Cancelled
      </div>
    );
  }

  if (attachment.properties?.prescriptionStatus === 'pending') {
    if (attachment.properties?.source !== PHARMACY_SOURCE_LIFEPACK) {
      return (
        <div className={style.status}>
          <SpinClock />
          Awaiting payment
        </div>
      );
    }

    if (
      attachment.properties?.lifepackPrescriptionStatus ===
      LifepackPrescriptionStatus.PENDING_ADDRESS
    ) {
      return (
        <div className={style.status}>
          <SpinClock />
          Awaiting payment
        </div>
      );
    }

    return (
      <div className={style.status}>
        <SpinClock />
        Pending
      </div>
    );
  }

  // Old logic, may need to remove this
  if (
    getStatusPayment(attachment) === 'pending' &&
    attachment.actions?.filter(e =>
      [
        'memo_lock',
        'order_medicine',
        'make_pos_payment',
        'medicine_request_view_order',
        'medicine_request_view_detail',
        'social_prescription_request_view_detail',
        'social_prescription_request_view_order',
        'social_prescription_request.doctor.issue',
      ].includes(e.type),
    ).length > 0
  ) {
    return (
      <div className={style.status}>
        <SpinClock />
        Awaiting payment
      </div>
    );
  }

  return '';
};

const renderAttachmentSubtitle = attachment => {
  if (!attachment) return null;

  const { id, properties } = attachment;

  let text;

  switch (id) {
    case 'emc.doctor_create':
      text = `No. ${properties?.no}`;
      break;
    case 'digi_emc.doctor_create':
      text = `DigiMC no. ${properties?.no}`;
      break;
    default:
      text = '';
      break;
  }

  if (!text) return null;
  return <div className={style.certNo}>{text}</div>;
};

const MessageAction = ({ message: { message, metadata }, userUuid, openMedicalCertificate }) => {
  const dispatch = useDispatch();
  const { isOpenFile, fileId, openFile, onClose, fileName } = useOpenFile();
  const [medicineRequestId, setMedicineRequestId] = useState(null);
  const [openModalConfirmVoidCert, setOpenModalConfirmVoidCert] = useState(false);
  const {
    attachment: { actions, body, id, content, properties },
  } = message;
  const listAction = getActions(actions, userUuid);

  const { voidACert } = useVoidCert();

  const {
    certification: { errors, status },
  } = useSelector(state => state.webChat.emc);

  const { id: drId } = useSelector(state => state.doctors.profile);

  const certId = id === 'emc.doctor_create' ? properties?.certId : '';

  const toggleModalConfirmVoidCert = () => {
    setOpenModalConfirmVoidCert(prev => !prev);
  };

  const onClickAction = useCallback(
    ({ type, extraData }) => {
      switch (type) {
        case 'memo_view_detail': {
          dispatch(
            addModal({
              type: 'memorandom',
              id: 3,
              data: {
                extraData,
              },
            }),
          );
          // openFile(extraData.memoFileId, 'Memo.pdf');
          break;
        }
        case 'referral_memo_view_detail': {
          openFile(extraData.referralMemoFileId, 'Referral Letter.pdf');
          break;
        }
        case 'art_view_detail': {
          dispatch(
            addModal({
              type: 'patientInfo',
              id: 1,
              data: {
                properties,
              },
            }),
          );
          break;
        }
        case 'view_prescription': {
          dispatch(
            addModal({
              type: 'prescription',
              id: 2,
              data: {
                prescriptionId: properties.prescriptionId,
              },
            }),
          );
          break;
        }
        case 'action_forward_emc': {
          openFile(extraData.fileId, 'EMC.pdf');
          break;
        }
        case 'action_create_emc': {
          openMedicalCertificate({ ...metadata, ...extraData });
          break;
        }
        case 'view_digi_emc': {
          dispatch(
            addModal({
              type: MODAL_TYPES.PREVIEW_DIGI_MC,
              id: MODAL_TYPES.PREVIEW_DIGI_MC,
              data: {
                certId: extraData.certId,
                onClose: () => dispatch(removeModal(MODAL_TYPES.PREVIEW_DIGI_MC)),
              },
            }),
          );
          break;
        }
        case 'doctor_create_pos': {
          break;
        }
        case 'pos_view_detail': {
          dispatch(
            addModal({
              type: 'pointOfSale',
              id: 4,
              data: {
                posId: properties.posId,
              },
            }),
          );
          break;
        }
        case 'social_prescription_request_view_detail':
        case 'medicine_request_view_detail': {
          setMedicineRequestId(extraData.medicineRequestId);
          break;
        }
        default:
          break;
      }
    },
    [metadata, openMedicalCertificate, openFile],
  );

  const expiredClass =
    properties?.status === EXPIRED_STATUS || properties?.certStatus === CERT_VOIDED_STATUS
      ? style.expired
      : '';

  const handleVoidCert = async () => {
    await voidACert(certId);
    toggleModalConfirmVoidCert();
    onClose();
  };

  return (
    <div className={expiredClass}>
      <div className={style.content}>
        <div className={style.left}>
          <div className={style.title}>
            {message?.attachment?.id === 'issue.patient.create' ? 'Issue' : body}
          </div>
          {/* <div className={style.meta}>
            {moment.utc(createdAt).local().format('MMM DD, YYYY HH:mm')}
          </div> */}
        </div>
        <div className={style.icon}>
          <Image src={IMAGES[id]} />
        </div>
      </div>
      <div>
        <div className={style.bodyContent}>
          {message?.attachment?.id === 'issue.patient.create' && body}
          {renderAttachmentSubtitle(message?.attachment)}
          {message?.attachment?.id === 'ai_face_scan.detail' && (
            <FaceScanScore overall={listAction[0]?.extraData?.overall} />
          )}
          {message?.attachment?.id === 'doctor_create_pos' ? (
            <div className={style.description}>{message?.attachment?.content[0]?.body}</div>
          ) : (
            id !== 'art.patient.detail' &&
            content?.map(({ key, contentBody, title }) => (
              <div key={key} className={style.itemContent}>
                <div className={style.itemTitle}>{title}</div>
                <div className={style.itemBody}>{contentBody}</div>
              </div>
            ))
          )}
          {renderPrice(message?.attachment)}
          {renderStatus(message?.attachment)}
        </div>
        {listAction.length > 0 && (
          <div className={style.bodyAction}>
            {listAction.map(i => (
              <Button
                key={i.type}
                content={formatTitle(i.type, i.title)}
                fluid
                onClick={() => onClickAction(i)}
              />
            ))}
          </div>
        )}
        {renderPaidImg(message?.attachment)}
      </div>
      {isOpenFile && (
        <ModalPDFView
          fileId={fileId}
          onClose={onClose}
          fileName={fileName}
          extraAction={
            properties?.doctorId === drId && properties?.certStatus !== CERT_VOIDED_STATUS ? (
              <Button style={{ fontWeight: 600 }} basic icon onClick={toggleModalConfirmVoidCert}>
                <Space size={4} direction="horizontal">
                  <Icon name="trash alternate outline" />
                  Void
                </Space>
              </Button>
            ) : (
              <></>
            )
          }
        />
      )}
      {medicineRequestId && (
        <ModalMedicineRequest
          close={() => setMedicineRequestId(null)}
          data={{ id: medicineRequestId, consultId: metadata.consultId, title: body }}
        />
      )}
      <ConfirmModal
        title="Void MC"
        message="By proceeding, this MC will be voided and this action cannot be undone."
        confirmButtonText="Void"
        showModal={openModalConfirmVoidCert}
        onSubmit={handleVoidCert}
        onClose={toggleModalConfirmVoidCert}
        error={errors?.voidMC}
        loading={status.voidMC === 0}
      />
    </div>
  );
};

MessageAction.propTypes = {
  message: shape({}).isRequired,
  userUuid: string.isRequired,
  openMedicalCertificate: func.isRequired,
};

MessageAction.defaultProps = {};

export default MessageAction;
